module.exports = __webpack_public_path__ + "static/media/hallazgos-reliquia-nuevo-estuche.37f5efbf.jpg";